import { createMachine } from 'xstate';

export const allongeeMachine = createMachine({
  id: 'allongee',
  initial: 'al-Sitting Idle 2',
  states: {
    "al-Getting Up": { on: { "NEXT01": "al-Getting Up 2" }},
    "al-Getting Up 2": { on: { "NEXT01": "al-Getting Up 29001" }},
    "al-Getting Up 29001": { on: { "NEXT01": "al-Kicking Out" }},
    "al-Kicking Out": { on: { "NEXT01": "al-Laying" }},
    "al-Laying": { on: { "NEXT01": "al-Laying Idle" }},
    "al-Laying Idle": { on: { "NEXT01": "al-Laying Idle9001" }},
    "al-Laying Idle9001": { on: { "NEXT01": "al-Laying9001" }},
    "al-Laying9001": { on: { "NEXT01": "al-Sitting Idle" }},
    "al-Sitting Idle": { on: { "NEXT01": "al-Sitting Idle 2" }},
    "al-Sitting Idle 2": { on: { "NEXT01": "al-Sitting Idle 29001" }},
    "al-Sitting Idle 29001": { on: { "NEXT01": "al-Sitting Idle9001" }},
    "al-Sitting Idle9001": { on: { "NEXT01": "al-Stand Up" }},
    "al-Stand Up": { on: { "NEXT01": "al-Stand Up9001" }},
    "al-Stand Up9001": { on: { "NEXT01": "al-Standing Up" }},
    "al-Standing Up": { on: { "NEXT01": "al-Standing Up9001" }},
    "al-Standing Up9001": { on: { "NEXT01": "al-Start Bicycle Sit Up" }},
    "al-Start Bicycle Sit Up": { on: { "NEXT01": "al-Start Bicycle Sit Up9001" }},
    "al-Start Bicycle Sit Up9001": { on: { "NEXT01": "al-Stunned" }},
    "al-Stunned": { on: { "NEXT01": "al-Zombie Stand Up" }},
    "al-Zombie Stand Up": { on: { "NEXT01": "al-Zombie Stand Up 2" }},
    "al-Zombie Stand Up 2": { on: { "NEXT01": "al-Getting Up 29002" }},
    "al-Getting Up 29002": { on: { "NEXT01": "al-Getting Up" }},
  }
});
